<template>
  <div>
    <!--微信分享弹出提示图片-->
    <van-overlay :show="showOverlay" @click="showOverlay = false">
      <div class="wechat-tips-pic" @click.stop>
        <img src="../../assets/img/guide.png"/>
      </div>
    </van-overlay>
  </div>
</template>

<script>
  import mobileType from '@/utils/mobileType';
  import browserType from '@/utils/browserType';
  import util from '@/utils/util';
  import wx from 'weixin-js-sdk';
  import QRCode from 'qrcodejs2';

  export default {
    props: ['params', 'sharePlatformList'],
    data() {
      return {
        showOverlay: false,
      };
    },
    created() {
    },
    mounted() {
      // if (browserType.isWeixin()) {
      //   this.getJsSdkSignatureFun();
      // }
    },
    watch: {
      // sharePlatformList: {
      //   handler(val) {
      //     this.showShare1 = val;
      //   },
      //   deep: true
      // }
    },
    methods: {
      //APP分享或跳转页面
      async jumpPage() {
        if (this.params.platform == 1 || this.params.platform == 2) {
          let arr = this.sharePlatformList;
          let trnasferBase64List = [];
          for (let i = 0; i < arr.length; i++) {
            if (arr[i].platformTag == 5) {
              if (arr[i].imgBase64) {
                await util.imageUrlToBase64(arr[i].imgBase64)
                  .then(res => {
                    arr[i].imgBase64 = res;
                    trnasferBase64List.push({
                      imgBase64: res,
                      platformTag: arr[i].platformTag,
                    });
                  });
              } else {
                trnasferBase64List.push({
                  imgUrl: arr[i].imgUrl,
                  platformTag: arr[i].platformTag,
                });
              }
            } else {
              trnasferBase64List.push(arr[i]);
            }
          }
          let params = {
            sharePlatformList: trnasferBase64List,//传多个参数给原生(为对象类型)
          };
          this.$apiFun.pushShareFun(params);
        } else if (this.params.platform == 3) {
          this.showOverlay = !this.showOverlay;
        } else {
          if (browserType.isWeixin()) {
            this.getJsSdkFun();
            this.showOverlay = !this.showOverlay;
          } else {
            let form_tone = this.sharePlatformList[0].url;
            let _input = document.createElement('input');   // 直接构建input
            _input.value = form_tone;  // 设置内容
            document.body.appendChild(_input);    // 添加临时实例
            _input.select();   // 选择实例内容
            document.execCommand('Copy');   // 执行复制
            document.body.removeChild(_input); // 删除临时实例
            this.$toast('已经复制链接，快去微信分享好友吧！');
          }
        }
      },
      // 获取JsSdk签名
      getJsSdkFun() {
        let params=this.params;
        let sharePlatformList = this.sharePlatformList[0];
        this.$apiFun.getJsSdkSignatureFun(params,sharePlatformList);
      }
    },
  };
</script>
<style lang="less" scoped>
  .van-popup--bottom.van-popup--round {
    /*border-radius: 0;*/
  }

  .van-popup--center.van-popup--round {
    border-radius: 10px;
  }

  .qrcode-box {
    padding: 20px;

    .qrcode-pic {
      img {
        width: 300px;
        height: auto;
        display: block;
      }
    }

    .qrcode-font001 {
      text-align: center;
      padding-top: 10px;
    }
  }

  .poster-box {
    padding: 20px;

    .poster-pic {
      img {
        width: 300px;
        height: auto;
        display: block;
      }
    }

    .poster-font001 {
      text-align: center;
      padding-top: 10px;
    }
  }

  .wechat-tips-pic {
    text-align: right;
    padding-right: 1rem;
    float: right;
    width: 60%;

    img {
      width: 100%;
      height: auto;
    }
  }
</style>
